import React, { useEffect } from "react";
import TickIcon from "../../../../../components/Common/SvgIcons/ManageIcons/TickIcon";
import { FormProvider, useForm } from "react-hook-form";
import Button from "../../../../../components/Common/Button/Button";
import { useNavigate, useOutletContext } from "react-router";
import { addTopicActionHandler } from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import classes from "./PublishNewTopic.module.scss";
import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";
import { addNewTopic } from "../../../../../utils/mainTabs/organize/addNewTopic";

const PublishNewTopic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formData, setFormData, tenantName, dataForUpdateTopicByID } = useOutletContext();
  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      ...formData.details,
      ...formData.topicContent,
    },
  });
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    watch,
    setValue,
  } = methods;
  const clearAll = () => {
    reset();
  };
  const onSubmit = (data) => {
    // let postData = {
    //   Description: formData?.details?.description,
    //   ImageUrl: formData?.details?.thumbnailImageFile,
    //   IsPublished: data.publishbtn ? true : false,
    //   Name: formData?.details?.name,
    //   Tags: formData?.details?.TagList,
    //   TopicCourseAssociations: formData?.topicContent?.TopicCourseAssociations,
    //   TopicId: 0,
    // };
    // console.log(postData);
    // debugger;
    // dispatch(addTopicActionHandler(postData)).then((response) => {
    //   debugger;
    //   if (response.status === 200) {
    //     dispatch(
    //       setErrorHandler(errorTypes.SUCCESS, "New Topic Published successfully")
    //     );
    //     navigate(`${topicManagement.path(tenantName)}`);
    //   }
    // });
    navigate(`${topicManagement.path(tenantName)}`);
  };
  useEffect(() => {
    setTimeout(() => {
      navigate(`${topicManagement.path(tenantName)}`);
    }, 5000);
  }, []);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.publisheMain}>
          <div className={classes.body}>
            <TickIcon fill={"#0da812"} />
            New Subtopic has been{" "}
            {dataForUpdateTopicByID?.IsPublished
              ? "UnPublished"
              : "Published"}{" "}
            Successfully.
            <div className={classes.linkRedirect}>
              You will be redirected to Subtopic automatically after 5 sec
            </div>
          </div>
          <div className={classes.footer}>
            {/* <div
              className={classes.clearAll}
              onClick={() => navigate(`${addNewTopic.path}/topicContent`)}
            >
              Cancel
            </div> */}
            {/* <Button
              label="View Topic"
              type="submit"
              name="publishbtn"
              small
              dark
              // onClick={setValue("publishbtn", true)}
            /> */}
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default PublishNewTopic;
